import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.delivery_charge_dialog.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const initAutoLc = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    header: {
        title: "@:{'resource.order.delivery_charge'}",
    },
    list_area: {
        title: "@:{'resource.order.delivery_charge'}",
        add: "배달대행료 추가",
        selected_item_delete: "선택항목삭제",
        search_placeholder: "도착지(지명)",
    },
    table_header: {
        id: "아이디",
        type: "구분",
        time: "시간",
        special_area: "도착지(지명)",
        distance_start: "시작KM(이상)",
        distance_end: "도착KM(미만)",
        jibun_above: "번지시작(이상)",
        jibun_below: "번지종료(이하)",
        area_name: "구역명",
        charge: "대행료",
        surcharge: "할증배달대행료",
        week: "적용요일",
        manage: "수정",
    },
    form_area: {
        title: [
            "배달대행료 추가",
            "배달대행료 수정 / {0}",
        ],
        store_name: "상점명",
        special_area: "도착지(지명)",
        working_day: "요일별할증",
        business_hour: "시간",
        charge: "대행료",
        distance_and_area: "거리 + 구역할증 요금제",
        surcharge: "할증배달대행료",
        surcharge_include_charge: "* 대행료포함",
        delivery_charge_type: "구분",
        delivery_charge_type_radio: {
            distance: "거리별/지명",
            jibun: "번지",
            area: "구역",
        },
        distance: "거리KM(이상~미만)",
        distance_sub_text: "* 소수점 1자리까지",
        jibun: "번지(이상~이하)",
        require_jibun: "시작 값이 작거나 같아야 합니다.",
        area: "지도구역지정",
        select_area: "구역선택",
        create: "배달대행료 추가",
        edit: "수정",
        edit_cancel: "취소",
    },
    dialog: {
        title: "구역선택",
    },
    dialog_delete: {
        title: "선택항목삭제",
    },
    dialog_cancel_edit: {
        title: "입력 취소",
    },
};
